class StripeHelper{

  stripe = null
  stripeForm = null
  stripeCardNumber = null
  stripeCardExpiry = null
  stripeCardCvc = null
  elements = null
  style = null

  titularElement = null
  publicKey = null
  constructor(publicKey){
    this.publicKey = publicKey
    this.style = {
      base: {
        color: '#969BA4',
        fontWeight: '500',
        lineHeight: '3.5rem',
        fontFamily: 'Poppins, sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '16px',
        '::placeholder': {
          color: '#969BA4'
        }
        // height: '3.5rem',
      },
      invalid: {
        color: '#C13515',
        iconColor: '#C13515'
      },
    };
    this.initStripe()
  }

  initStripe(){
    if (typeof Stripe !== 'undefined') {
      this.stripe = Stripe(this.publicKey);
      this.elements = this.stripe.elements({
        fonts: [
          {
            cssSrc: 'https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600&display=swap', // Fuente externa
          },
        ],
      });
    }
    else{
      console.log("Stripe is not initialized.");
    }
  }

  initFormLine(selector){
    if (this.stripe == null || document.querySelector(selector) == null) {
      setTimeout(() => {
        if(this.stripe == null){
          this.initStripe()
        }
        this.initFormLine(selector)
      }, 100)
      return
    }
    // Create an instance of the card Element
    this.stripeForm = this.elements.create('card', {
      style: this.style,
      hidePostalCode: true
    });

    // Add an instance of the card Element into the `card-element` <div>
    this.stripeForm.mount(selector);

    // Handle real-time validation errors from the card Element.
    this.stripeForm.addEventListener('change', function(event) {
      var displayError = document.getElementById('card-errors');
      if (event.error) {
        displayError.textContent = event.error.message;
      } else {
        displayError.textContent = '';
      }
    });
  }

  initForm(selectorCard, selectorExpiry, selectorCvv, selectorTitular){

    if (this.stripe == null || document.querySelector(selectorCard) == null ||
      document.querySelector(selectorExpiry) == null || document.querySelector(selectorCvv) == null
    || document.querySelector(selectorTitular) == null) {
      setTimeout(() => {
        if(this.stripe == null){
          this.initStripe()
        }
        this.initForm(selectorCard, selectorExpiry, selectorCvv, selectorTitular)
      }, 100)
      return
    }

    this.titularElement = document.querySelector(selectorTitular)

    let style = this.style
    this.stripeCardNumber = this.elements.create('cardNumber', {
      style,
      showIcon: true,
      placeholder: 'XXXX-XXXX-XXXX-XXXX',
    });
    this.stripeCardExpiry = this.elements.create('cardExpiry', { style });
    this.stripeCardCvc = this.elements.create('cardCvc', { style });

    // Montar los elementos en los divs correspondientes
    this.stripeCardNumber.mount(selectorCard);
    this.stripeCardExpiry.mount(selectorExpiry);
    this.stripeCardCvc.mount(selectorCvv);

    // Manejar errores de validación
    this.stripeCardNumber.on('change', event => {
      const displayError = document.getElementById('card-errors');
      if (event.error) {
        displayError.textContent = event.error.message;
      } else {
        displayError.textContent = '';
      }
    });
  }

  clear(){
    if(this.stripeForm != null){
      this.stripeForm.unmount();
    }
    else{
      this.stripeCardNumber.unmount();
      this.stripeCardExpiry.unmount();
      this.stripeCardCvc.unmount();
    }
  }

  async tokenizar() {
    if(this.stripeForm != null){
      return this.tokenizarFormLine()
    }
    return this.tokenizarForm()
  }

  async tokenizarFormLine() {
    let result = await this.stripe.createToken(this.stripeForm)
    if(result.error){
      let errorElement = document.getElementById('card-errors');
      errorElement.textContent = result.error.message;
      return null
    }
    return result.token.id
  }

  async tokenizarForm() {
    const cardholderName = this.titularElement.value;
    let result = await this.stripe.createPaymentMethod({
      type: 'card',
      card: this.stripeCardNumber, // Elemento de tarjeta
      billing_details: {
        name: cardholderName, // Nombre del titular de la tarjeta
      },
    });

    if(result.error){
      let errorElement = document.getElementById('card-errors');
      errorElement.textContent = result.error.message;
      return null
    }
    return result.paymentMethod.id
  }
}
export default StripeHelper
